module.exports = __webpack_public_path__ + "/build/web/images/hero-matching-pillows@2x.500779c33864d5dbfbeaf1c94c36a1de.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-matching-pillows@2x.jpg
// module id = 140
// module chunks = 13